import { render, staticRenderFns } from "./MicroAnimationButton.vue?vue&type=template&id=2cdd8b8c&scoped=true&"
import script from "./MicroAnimationButton.vue?vue&type=script&lang=js&"
export * from "./MicroAnimationButton.vue?vue&type=script&lang=js&"
import style0 from "./MicroAnimationButton.vue?vue&type=style&index=0&id=2cdd8b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd8b8c",
  null
  
)

export default component.exports